module.exports = __webpack_public_path__ + "static/media/LHAInSwing.1432f7d6.svg";